export const ADD_SUB_PAGE_OPTIONS = {
  TEXT_SUB_PAGE: 'TEXT_SUB_PAGE',
  MEDIA_SUB_PAGE: 'MEDIA_SUB_PAGE',
};
